export const CACHE_TTL_MS = 10 * 60 * 1000;

/** Keeps successful lookups for a fixed time so repeat visits skip the network */
export class TtlCache<V> {
  private entries = new Map<string, { value: V; storedAt: number }>();

  constructor(private readonly ttlMs: number = CACHE_TTL_MS, private readonly now: () => number = Date.now) { }

  get(key: string): V | undefined {
    const entry = this.entries.get(key);
    if (!entry) {
      return undefined;
    }
    if (this.now() - entry.storedAt >= this.ttlMs) {
      this.entries.delete(key);
      return undefined;
    }
    return entry.value;
  }

  set(key: string, value: V): V {
    this.entries.set(key, { value, storedAt: this.now() });
    return value;
  }

  /** Resolves from cache when fresh; otherwise loads and stores only a successful result */
  getOrLoad(key: string, load: () => Promise<V>, forceRefresh: boolean = false): Promise<V> {
    const cached = forceRefresh ? undefined : this.get(key);
    return cached !== undefined ? Promise.resolve(cached) : load().then((value) => this.set(key, value));
  }
}
